"use strict";const e=require("./styled-4fe2d839.js");function r(s){return e.useThemeProps}exports.createUseThemeProps=r;
